import { render, staticRenderFns } from "./guess-want.vue?vue&type=template&id=28329c41&scoped=true&"
import script from "./guess-want.vue?vue&type=script&lang=ts&"
export * from "./guess-want.vue?vue&type=script&lang=ts&"
import style0 from "./guess-want.vue?vue&type=style&index=0&id=28329c41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28329c41",
  null
  
)

export default component.exports